document.addEventListener("DOMContentLoaded", function () {
  window.free_shipping = false;
  let isFreeStatus = false;

  function fetchCartData(callback) {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => callback(null, data))
    .catch(error => {
      console.error('Error al obtener el carrito:', error);
      callback(error, null);
    });
  }

  function isFree(callback) {
    fetchCartData((error, data) => {
      if (error) {
        callback(false);
      } else {
        const totalPrice = data.total_price;
        callback(totalPrice > 120000);
      }
    });
  }

  function cartTotal(callback) {
    fetchCartData((error, data) => {
      if (error) {
        callback(false);
      } else {
        const totalPrice = data.total_price;
        const difference = 120000 - totalPrice; 
        callback(difference > 0 ? difference : 0);
      }
    });
  }

  function applyFreeShipping() {
    const url = `${window?.Shopify?.routes?.root}discount/ENVIOGRATIS`;
    fetch(url);
  }

  function updateBar(status, difference) {
    setTimeout(function () {
      const diff = Shopify.formatMoney(difference);
      const currentTotal = 120000 - difference;
      const percentage = (currentTotal / 100) * 0.077;

      const shadowHost = document.querySelector('#upCart');
      if (shadowHost) {
        const rewardsBar = document.querySelector('.upcart-rewards-bar-foreground');
        if (rewardsBar) {
          rewardsBar.style.width = status ? '100%' : `${percentage}%`;
        }

        const rewardsTierCircle = document.querySelector('.upcart-rewards-tier-circle');
        if (rewardsTierCircle) {
          rewardsTierCircle.style.border = '2px solid rgb(0, 0, 0)';
          rewardsTierCircle.style.backgroundColor = status ? 'rgb(0,0,0)' : 'rgb(255 255 255)';
          rewardsTierCircle.style.fill = status ? 'rgb(255 255 255)' : 'rgb(0, 0, 0)';
        }

        const rewardsMessage = document.querySelector('.upcart-rewards-message p');
        if (rewardsMessage) {
          rewardsMessage.innerHTML = status
            ? '<p><span style="color: rgb(0, 0, 0);">¡Felicidades! Ya tienes <strong>ENVÍO GRATIS</strong>!</span></p>'
            : `<p><span style="color: rgb(0, 0, 0);">Te faltan <strong>${diff}</strong> para <strong>ENVÍO GRATIS</strong></p>`;
        }
      } else {
        console.error('No se pudo acceder al Shadow DOM de #upCart. Asegúrate de que el host existe.');
      }
    }, 800);
  }

  function handleCartUpdate() {
    isFree(function (isFreeResult) {
      cartTotal(function (difference) {
        if (document.body.classList.contains('template-test-shipping')) {
          if (isFreeResult) {
            applyFreeShipping();
            updateBar(true, difference);
          } else {
            updateBar(false, difference);
          }
        }
      });
    });

    /*if (document.body.classList.contains('template-test-shipping')) {
      const rewardsDescription = document.querySelector('.upcart-rewards-message p');
      if (rewardsDescription) {
        rewardsDescription.textContent = '$1,200 ENVÍO GRATIS';
      }
    }*/
  }    

  //window.upcartOnCartOpened = handleCartUpdate;
  //window.upcartOnCartUpdated = handleCartUpdate;

  window.upcartOnCartOpened = function (cart) {
    handleCartUpdate();
  }

  window.upcartOnCartUpdated = function (cart) {
    setTimeout(function() {
      handleCartUpdate();
    }, 200);
  }

  window.upcartOnItemRemoved = function (cart) {
    setTimeout(function() {
      handleCartUpdate();
    }, 200);
  }

  handleCartUpdate();

  function updateCopys() {
    if (document.body.classList.contains('template-test-shipping')) {
      /*const rewardsDescription = document.querySelector('.upcart-rewards-message p');
      if (rewardsDescription) {
        rewardsDescription.textContent = '$1,200 ENVÍO GRATIS';
      }*/

      const announcementSpan = document.querySelector('.announcement-bar-text strong');
      if (announcementSpan) {
        announcementSpan.textContent = 'ENVÍO GRATIS A TODO MÉXICO EN PEDIDOS MAYORES A $1200.00';
      }

      const shippingStrong = document.querySelector('.free-shipping-total');
      if (shippingStrong) {
        shippingStrong.textContent = 'Arriba de $1,200 MXN';
      }
    }
  }

  updateCopys();

  setTimeout(function () {
    updateCopys();
  }, 100);

  setTimeout(function () {
    updateCopys();
  }, 400);

  setTimeout(function () {
    updateCopys();
  }, 800);
});